export default {
  name: "SpecificationDialog",
  props: {
    goodsInfo: {
      type: Object,
      default: {}
    },
    activeSku: {
      type: Number,
      default: null
    },
    totalPrice: {
      type: String,
      default: ""
    },
    selSpeci: {
      type: String,
      default: ""
    },
    pocket: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      dialogVisible: true,
      goodsNum: 0
    };
  },
  watch: {
    goodsInfo: {
      handler(val) {
        this.goodsInfo = val;
        this.loopCartItem(this.activeSku);
        return this.goodsInfo;
      },
      immediate: true
    },
    activeSku: {
      handler(val) {
        this.loopCartItem(val);
      }
    },
    pocket: {
      handler(val) {
        this.pocket = val;
        return this.pocket;
      }
    }
  },
  methods: {
    loopCartItem(val) {
      // 处理展示购物车里对应的规则属性所购买的数量
      let info = this.goodsInfo;
      this.goodsNum = 0;
      info.cartsItem.forEach(item => {
        if (item.sku_id === val && this.matchAttr(item.attr, info.attrs) && item.pocket === this.pocket) {
          this.goodsNum = item.num;
        }
      });
    },
    // 处理规格属性是否匹配
    matchAttr(attr, infoAttr) {
      let isMetch = true;
      for (let i = 0; i < attr.length; i++) {
        let item = attr[i];
        if (!this.handleAttrArr(item, infoAttr[i])) {
          isMetch = false;
          break;
        }
      }
      return isMetch;
    },
    handleAttrArr(attr, infoAttr, inx = 0) {
      if (inx > infoAttr.values.length - 1) {
        return false;
      }
      let infoAttrItem = infoAttr.values[inx];
      if (Number(attr.id) === infoAttrItem.id && infoAttrItem.checked) {
        return true;
      } else {
        return this.handleAttrArr(attr, infoAttr, inx + 1);
      }
    },
    addCart() {
      this.$emit("addCart", this.goodsInfo);
      this.loopCartItem(this.activeSku);
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit("close");
    },
    // 选择规格
    handleSku(obj) {
      if (obj.stock * 1 === 0) return;
      this.$emit("handleSku", obj);
    },
    // 选择规格属性
    selectAttr(attrIndex, attrObj, obj) {
      this.$emit("selectAttr", attrIndex, attrObj, obj);
      this.loopCartItem(this.activeSku);
    },
    handleNum(type, obj) {
      this.$emit("handleNum", type, obj);
    }
  }
};